export default __webpack_public_path__ + "static/top-background-1d3169912de91b663b21de3564ef59e4.png";